/**
 * Maps URL/refinement keys to Algolia numeric attribute names.
 * The homepage "past X time" control stores thresholds under `lastSeenMin` for URL
 * compatibility, but the intended product meaning is "posted since", so Algolia
 * filters use `postedDate`.
 */
export function refinementKeyToAlgoliaNumericAttribute(key: string): string {
  if (key === 'lastSeenMin') return 'postedDate';
  return key;
}
